<template lang="html">
  <div>
    <div id="peakOverlay">
      <draggable v-model="slideArray" class="row" @update="onUpdate">
        <div
          v-for="(slide, idx) in slideArray"
          :key="'slide_overlay' + idx"
          :style="thumbStyle(idx)"
          class="overlayThumbs"
        >
          <img :src="path_to_assets + slide.file">
        </div>
      </draggable>
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import draggable from 'vuedraggable'
export default {
  name: "PeakOverlay",
  components:{
    draggable
  },
  props:{
    zoom_pixels:{
      type: Number,
      default: () => 0
    },
    zoom_offset:{
      type: Number,
      default: () => 0
    },
    slide_array:{
      type: Array,
      default: () => []
    },
    slide_index:{
      type: Number,
      default: () => 0
    }
  },
  data(){
    return {
      positionArray: [],
      slideArray: [],
      moving: false,
      thumb_size: 90,
      thumb_padding: 4,
      throttledArrangeThumbs: null
    }
  },
  computed:{
    zoomPixels(){
      return this.zoom_pixels;
    },
    path_to_assets(){
      return `https://s3.amazonaws.com/users.soundslides.media/${this.$store.state.currentShowDetails.ssid}/`
    }
  },
  watch:{
    zoom_offset(){
      this.throttledArrangeThumbs();
    },
    slideArray(){
      this.throttledArrangeThumbs();
    },
    zoomPixels(){
      this.throttledArrangeThumbs();
    },
    slide_array(value){
      this.slideArray = value;
    }
  },
  mounted(){
    this.arrangeThumbs();
    this.slideArray = this.slide_array;
    this.throttledArrangeThumbs = _.throttle(this.arrangeThumbs, 100);
  },
  methods:{
    arrangeThumbs(){
      //console.log("arrangeThumbs");
      // Set the position of each thumb overlay.
      this.positionArray = _.map(this.slideArray, s => {
        var timing = s.timing / 1000;
        var width_adjustment_scale = 1.0013; // Correction for very small error, caused by percentage scale of Peak.
        if(this.zoomPixels < 30){
          width_adjustment_scale = 1.025
        }
        if(this.zoomPixels < 16){
          width_adjustment_scale = 1.075
        }

        var leftPx = ((timing * this.zoomPixels) * width_adjustment_scale) - this.zoom_offset;
        return {
          left: leftPx,
          row: 0
        }
      });
      var image_width = this.thumb_size;
      this.positionArray = _.map(this.positionArray, (p, idx) => {
        if(idx != 0){
          if(Math.abs(p.left - this.positionArray[idx - 1].left) < (image_width + this.thumb_padding)){
            // Too close, move rows.
            if(this.positionArray[idx - 1].row > 0){
              // Check to see if *that* one is closer.
              if(Math.abs(p.left - this.positionArray[idx - 2].left) < (image_width + this.thumb_padding)){
                p.row = this.positionArray[idx - 1].row + 1;
              }else{
                p.row = 0;
              }
            }else{
              p.row = this.positionArray[idx - 1].row + 1;
            }
          }
        }
        return p
      })
    },
    adjustThumbSize(amount){
      this.thumb_size = this.thumb_size * amount;
      this.arrangeThumbs();
    },
    thumbStyle(idx){
      //console.log("thumbStyle")
      var leftPos = this.positionArray[idx].left + 'px';
      var topPos = ((this.positionArray[idx].row + 1) * -(this.thumb_size + this.thumb_padding)) + 600 + 'px';
      var style = {
        'position': 'absolute',
        'left': leftPos,
        'top': topPos,
        'width': this.thumb_size + 'px',
        'height': this.thumb_size + 'px'
      };
      // If idx is active, return with border.
      if(idx == this.slide_index){
        var border_width = 2;
        style = {
          'position': 'absolute',
          'left': leftPos,
          'top': topPos,
          'width': (this.thumb_size - (2 * border_width)) + 'px',
          'height': (this.thumb_size - (2 * border_width)) + 'px',
          'border-style': 'solid',
          'border-width': border_width + 'px'
        }
      }
      return style;
    },
    onUpdate(evt){
      console.log(evt);
      //console.log("Index", evt.oldIndex)
      //console.log("Moving to ... ", evt.newIndex)
      this.$emit("onOrderChange", this.slideArray);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/Editor/_variables.scss";

#peakOverlay{
  position: absolute;
  top: 0px;
  height: 600px;
  width: 100%;
  z-index: 100;
  //background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6)) !important;
  overflow: hidden;
}
.overlayThumbs{
  display: inline-block;
  //float: left;
  overflow: hidden;
  //background-color: #FCFCFC;
  background-color: $timeline-thumb-background;
  box-shadow: $timeline-thumb-shadow;
  border-color: $grid-thumb-highlights;
  img{
    position: relative;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    max-width: 100%;
    max-height: 100%;
  }
}

</style>
